import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React, { useState } from 'react';
import cls from 'classnames';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/notification/constants';
import HookNotice from './HookNotice';
import '@douyinfe/semi-foundation/lib/es/notification/notification.css';
import getUuid from '@douyinfe/semi-foundation/lib/es/utils/uuid'; // TODO: Automatic folding + unfolding function when there are more than N

const defaultConfig = {
  duration: 3,
  position: 'topRight',
  motion: true,
  content: '',
  title: '',
  zIndex: 1010
};

function usePatchElement() {
  const [elements, setElements] = useState([]);

  function patchElement(element, config) {
    setElements(originElements => [{
      element,
      config
    }, ...originElements]);
    return id => {
      setElements(originElements => _filterInstanceProperty(originElements).call(originElements, _ref => {
        let {
          config: configOfCurrentElement
        } = _ref;
        return configOfCurrentElement.id !== id;
      }));
    };
  }

  function renderList() {
    var _context;

    const noticesInPosition = {
      top: [],
      topLeft: [],
      topRight: [],
      bottom: [],
      bottomLeft: [],
      bottomRight: []
    };

    _forEachInstanceProperty(elements).call(elements, _ref2 => {
      let {
        element,
        config
      } = _ref2;
      const {
        position
      } = config;
      noticesInPosition[position].push(element);
    });

    return _mapInstanceProperty(_context = _Object$entries(noticesInPosition)).call(_context, obj => {
      const pos = obj[0];
      const notices = obj[1]; // @ts-ignore

      return _Array$isArray(notices) && notices.length ? /*#__PURE__*/React.createElement("div", {
        key: pos,
        className: cls(cssClasses.LIST),
        placement: pos
      }, notices) : null;
    });
  }

  return [renderList(), patchElement];
}

export default function useNotification() {
  const [elements, patchElement] = usePatchElement();
  const noticeRef = new _Map();
  const id = getUuid('semi_notice_');

  const addNotice = config => {
    const mergeConfig = _Object$assign(_Object$assign({}, config), {
      id
    }); // eslint-disable-next-line prefer-const


    let closeFunc;

    const ref = ele => {
      noticeRef.set(id, ele);
    };

    const notice = /*#__PURE__*/React.createElement(HookNotice, _Object$assign({
      key: id
    }, mergeConfig, {
      afterClose: instanceID => closeFunc(instanceID),
      ref: ref
    }));
    closeFunc = patchElement(notice, _Object$assign({}, mergeConfig));
    return id;
  };

  const removeElement = instanceID => {
    const ele = noticeRef.get(instanceID);
    ele && ele.close();
  };

  return [{
    success: config => addNotice(_Object$assign(_Object$assign(_Object$assign({}, defaultConfig), config), {
      type: 'success'
    })),
    info: config => addNotice(_Object$assign(_Object$assign(_Object$assign({}, defaultConfig), config), {
      type: 'info'
    })),
    error: config => addNotice(_Object$assign(_Object$assign(_Object$assign({}, defaultConfig), config), {
      type: 'error'
    })),
    warning: config => addNotice(_Object$assign(_Object$assign(_Object$assign({}, defaultConfig), config), {
      type: 'warning'
    })),
    open: config => addNotice(_Object$assign(_Object$assign(_Object$assign({}, defaultConfig), config), {
      type: 'default'
    })),
    close: removeElement
  }, /*#__PURE__*/React.createElement(React.Fragment, null, elements)];
}